import type { Theme } from '@mui/material/styles'

type Owner = { theme: Theme }

const Table = () => ({
  MuiTableContainer: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({
        boxShadow: theme.shadows[0],
        borderTopColor: theme.palette.divider,
      }),
    },
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        textTransform: 'uppercase' as const,
        '& .MuiTableCell-head': {
          fontSize: '0.75rem',
          letterSpacing: '1px',
        },
      },
    },
  },
  MuiTableBody: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({
        '& .MuiTableCell-body': {
          letterSpacing: '0.25px',
          color: theme.palette.text.secondary,
          '&:not(.MuiTableCell-sizeSmall):not(.MuiTableCell-paddingCheckbox):not(.MuiTableCell-paddingNone)': {
            paddingTop: theme.spacing(3.5),
            paddingBottom: theme.spacing(3.5),
          },
        },
      }),
    },
  },
  MuiTableRow: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({
        '& .MuiTableCell-head:not(.MuiTableCell-paddingCheckbox):first-of-type, & .MuiTableCell-root:not(.MuiTableCell-paddingCheckbox):first-of-type': {
          paddingLeft: theme.spacing(6),
        },
        '& .MuiTableCell-head:last-child, & .MuiTableCell-root:last-child': {
          paddingRight: theme.spacing(6),
        },
      }),
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: ({ theme }: Owner) => ({ borderBottom: `1px solid ${theme.palette.divider}` }),
      stickyHeader: ({ theme }: Owner) => ({
        backgroundColor: theme.palette.customColors.tableHeaderBg,
      }),
    },
  },
})

export default Table
